import { render, staticRenderFns } from "./RequestPacking.vue?vue&type=template&id=af5d8b70&"
import script from "./RequestPacking.vue?vue&type=script&lang=js&"
export * from "./RequestPacking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports